import { defineChain } from "viem";
import * as viemChains from "viem/chains";

// --- Build-time unknown the spec flags (§3) ---------------------------------
// Whether the installed `viem` already exports `arcTestnet` from `viem/chains`
// varies by version. We import the whole namespace (which never throws on a
// missing member) and prefer the official export if present, otherwise fall
// back to a local defineChain.
//
// Note: the modular transport routes UserOp submission AND our reads through
// Circle's hosted backend URL (`${VITE_CLIENT_URL}/arcTestnet`), so the
// rpcUrls below are only a viem formality — they are not the live read path in
// this app. The chain id is a placeholder; confirm against Circle Arc docs
// before mainnet.
const arcTestnetFallback = defineChain({
  id: 8888, // TODO: confirm Arc testnet chainId from Circle docs.
  name: "Arc Testnet",
  nativeCurrency: { name: "USDC", symbol: "USDC", decimals: 6 }, // USDC-native gas
  rpcUrls: {
    default: { http: ["https://rpc.testnet.arc.circle.com"] }, // placeholder; reads go via modular transport
  },
  blockExplorers: {
    default: { name: "Arcscan", url: "https://testnet.arcscan.app" },
  },
  testnet: true,
});

// app 1.4.31 (17 Oct 2026) — Arc's public RPC moved from *.testnet.arc.network
// to *.testnet.arc.io (docs.arc.io → RPC endpoints), and viem's own list for the
// chain still names the old hosts, which no longer resolve. The note reads
// (ArcNoteSource: the Take page, a sent note's serial) go straight to these, so
// M names Arc's current four itself, in this order: Circle's primary, dRPC,
// QuickNode, Blockdaemon.
export const ARC_RPC_URLS = [
  "https://rpc.testnet.arc.io",
  "https://rpc.drpc.testnet.arc.io",
  "https://rpc.quicknode.testnet.arc.io",
  "https://rpc.blockdaemon.testnet.arc.io",
] as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const viemArc = (viemChains as any).arcTestnet;
export const arcTestnet = viemArc
  ? { ...viemArc, rpcUrls: { ...viemArc.rpcUrls, default: { ...viemArc.rpcUrls.default, http: [...ARC_RPC_URLS] } } }
  : arcTestnetFallback;
